export function formatCpf(cpf: string) {
  return cpf?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
}

export function unformatCpf(cpf: string) {
  return cpf?.replace(/\D/g, '')
}
